import React, { useEffect, useState } from 'react';
import { Button, Dialog, withStyles } from '@material-ui/core';
import PCProductDetails from './Details';
import ProductDelete from '../ProductDelete';

import { Redirect } from 'react-router';
import ChangePalette from '../ChangePalette';
import { hasPermission, createHistory } from '../../sc-utilities';
import PrintLabelForm from '../PrintLabelForm'
import { connect } from 'react-redux';
import * as action from '../../np-core/Auth/store/authActions';
import * as actions from './store/pcProductActions';
import * as userActions from '../../np-core/User/store/userActions';
import QRCode from 'qrcode.react';
import '../qrCode.scss';
import { socket } from '../../../index';
import AppLogoLoading from '../../sc-logo';
import { fetchBulkChangeProductsGroup, fetchGroups } from "../../sc-group/Group/store/groupActions";
import ChangeGroupModal from "../../sc-users/User/ChangeGroupModal";
import AuthenticatorAppModal from "../../sc-profile/YourSettings/AuthenticatorModal";
import { hardDelete } from "./store/pcProductActions";
import History from "../../../History";

const styles = theme => ({
    root: {
        backgroundColor: "transparent"
    },
    paper: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden"
    },
    fab: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: "#e62440",
        '&:hover': {
            backgroundColor: "#757575",
        },
    },
    logo: {
        width: '250px',
        margin: '10px'
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    columnHeaderStyle: {
        paddingTop: 20,
    },
    buttonOne: {
        marginRight: 5,
        marginTop: 5,
        borderRadius: '4px',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.buttonText.default,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    button: {
        marginRight: 5,
        marginTop: 5,
        borderRadius: '4px',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.buttonText.default,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    qrCode: {
        float: 'left',
        marginRight: "0.5%",
    },
    loading: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    deleteButton: {
        backgroundColor: theme.palette.error.main,
        marginRight: 5,
        marginTop: 5,
        borderRadius: '4px',
        color: theme.palette.buttonText.default,
        '&:hover': {
            backgroundColor: theme.palette.error.dark,
        }
    },
});

const ProductDetails = props => {
    const { setEditable, classes, setRefresh, tabValue, editable, unlockEdit, deletedMedia, setDeletedMedia, onLoadedCleanup, permissions, onFetchProduct, translations,
        activeCustomer, activeWarehouseID, refresh, fetchGrades, fetchGradingCategories, fetchTypicalProblems, onFetchGroups, onFetchBulkChangeProductsGroup, onFetchPCProduct,
        twoFaEnabled, onHardDelete, onSendErasureReports, onSendExternalData } = props;
    const [grades, setGrades] = useState([]);
    const [gradingCategories, setGradingCategories] = useState([]);
    const [typicalProblems, setTypicalProblems] = useState([]);
    const [changePaletteModalState, setChangePaletteModalState] = useState({ orders: [], open: false });
    const [redirectOptions, setRedirectOptions] = useState({ redirect: false, productID: null, redirectPath: '' });
    const [printLabelState, setPrintLabelState] = useState({ open: false, productID: null, printers: [] });
    const [isPrinted, setIsPrinted] = useState(false);
    const [external, setExternal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [show2fa, setShow2fa] = useState({ open: false, Authentications: {} });

    const [changeGroupModal, setChangeGroupModal] = useState({ open: false, ProductID: null });
    const [groups, setGroups] = useState({ list: [], loading: false });

    const getGroups = async () => {
        setGroups(prevState => { return { ...prevState, loading: true } });
        const result = await onFetchGroups({ ActiveCustomerID: activeCustomer });
        if (result.data) {
            setGroups(prevState => { return { ...prevState, list: result.data } });
        }
        setGroups(prevState => { return { ...prevState, loading: false } });
    }

    const productHistoriesHandler = productID => {
        createHistory();
        setRedirectOptions({ redirect: true, productID: productID, redirectPath: `/product/histories?productID=${productID}` });
    };

    useEffect(() => {
        const getUserSettings = async () => {
            const result = await props.fetchUserSettings({ ActiveCustomerID: activeCustomer });
            if (result) {
                setShow2fa(prevState => {
                    return { ...prevState, Authentications: result.Authentications }
                });
            }
        }
        getUserSettings();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            let gradeData = await fetchGrades({ ActiveCustomerID: activeCustomer });
            let gradingCategoryData = await fetchGradingCategories({ ActiveCustomerID: activeCustomer });
            let typicalProblemData = await fetchTypicalProblems({ ActiveCustomerID: activeCustomer });
            setLoading(true);
            setGrades(gradeData);
            setGradingCategories(gradingCategoryData);
            setTypicalProblems(typicalProblemData);
        }
        if (refresh && tabValue < 5 && tabValue !== 2) {
            setLoading(false)
            setRefresh(false)
        }

        if (!loading && tabValue < 5 && tabValue !== 2) {
            onFetchProduct({ ProductID: props.productID, ActiveCustomerID: activeCustomer });
            fetchData();
        }
        if (deletedMedia) {
            onFetchProduct({ ProductID: props.productID, ActiveCustomerID: activeCustomer });
            setDeletedMedia(false);
        }
        if (external) {
            onFetchProduct({ ProductID: props.productID, ActiveCustomerID: activeCustomer });
            setExternal(false)
        }

        // Connect to socket listener
        if (props?.product?.loaded?.DeviceOnlineStatus) {
            const workplaceClientSocketID = props?.product?.loaded?.DeviceOnlineStatus?.SocketID;
            const handleMessage = async () => {
                setLoading(true);
                let isEditable = await props.productEditable({ ProductID: props.productID, ActiveCustomerID: activeCustomer });
                setEditable({ editable: isEditable.productEditable, loading: true });
                await onFetchProduct({ ProductID: props.productID, ActiveCustomerID: activeCustomer });
                setLoading(false);
            }
            if (workplaceClientSocketID) {
                socket.on(`${props.productID}-${activeCustomer}-connected`, handleMessage);
                socket.on(`${workplaceClientSocketID}-disconnected`, handleMessage);
                socket.on(`${workplaceClientSocketID}-product-changed`, handleMessage);
            }

        }
        return () => {
            // Removes all listeners for this product topic
            if (props?.product?.loaded?.DeviceOnlineStatus) {
                const workplaceClientSocketID = props?.product?.loaded?.DeviceOnlineStatus?.SocketID;
                if (workplaceClientSocketID) {
                    socket.off(`${workplaceClientSocketID}-product-changed`);
                    socket.off(`${workplaceClientSocketID}-disconnected`);
                    socket.off(`${workplaceClientSocketID}-product-changed`);
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchGrades, refresh, props.tabValue, activeCustomer, fetchGradingCategories, external, fetchTypicalProblems, loading, onFetchProduct, onLoadedCleanup, props.productID, deletedMedia, setDeletedMedia]);
    const [deleteModalState, setDeleteModalState] = useState({ open: false, productID: null, productIDs: [], forBulk: false });
    const [redirect, setRedirect] = useState(false);

    const handleDelete = async event => {
        if (!editable) {
            return null;
        }
        if (!event) {
            setDeleteModalState({ open: false, productID: null, productIDs: [], forBulk: false });
            return;
        }
        if (event.deleted) {
            setDeleteModalState({ open: false, productID: null, productIDs: [], forBulk: false });
            setRedirect(true);
            return;
        }
        const productID = event.currentTarget.value;
        setDeleteModalState({ ...deleteModalState, open: true, productID: productID });
    };

    const handleChangePalette = async event => {
        if (!event) {
            props.onLoadedCleanup();
            props.onFetchProduct({ ProductID: props.productID, ActiveCustomerID: activeCustomer });
            setChangePaletteModalState({ orders: [], open: false });
            setLoading(false);
            return;
        }
        let orderData = await props.fetchOrders({ ActiveCustomerID: activeCustomer });
        let collies = await props.fetchCollies({ ActiveCustomerID: activeCustomer, q: { WarehouseID: activeWarehouseID, ProductTypeKeys: 'PCProduct' } });
        setChangePaletteModalState({ orders: orderData, open: true, Collies: collies });
    };

    const fetchData = async id => {
        await props.fetchUserSettings({ ActiveCustomerID: activeCustomer });
        let data = await props.onFetchPrinters({ ActiveCustomerID: activeCustomer });
        setPrintLabelState({ open: true, productID: id, printers: data });
    }
    const handlePrintLabel = async id => {
        if (!id) {
            setPrintLabelState({ open: false, productID: null, printers: [] });
            return;
        }
        let result = await props.onProductPrinted({ ActiveCustomerID: activeCustomer, ProductID: id })
        setPrintLabelState({ open: false, productID: id, printers: [] });
        setIsPrinted(result)
        fetchData(id);
    }

    const handleSendExternalData = async event => {
        await onSendExternalData({ ActiveCustomerID: activeCustomer, ProductIDs: [props.productID] });
    }
    const handleSendErasureReports = async event => {
        await onSendErasureReports({ ActiveCustomerID: activeCustomer, ProductIDs: [props.productID] });
    }

    const openChangeGroupModal = () => {
        if (hasPermission(permissions, 'group_list')) {
            getGroups();
        }
        setChangeGroupModal({ open: true });
    }

    const handleChangeGroupCloseSafe = () => {
        setChangeGroupModal({ open: false });
    }

    const handleChangeGroupCloseDanger = async (GroupID) => {
        setChangeGroupModal({ open: false });
        await onFetchBulkChangeProductsGroup({ ActiveCustomerID: activeCustomer, GroupID, ProductIDs: [product.ProductID] });
        await onFetchPCProduct({ ActiveCustomerID: activeCustomer, ProductID: props.productID });
    }

    const product = props.product.loaded;

    useEffect(() => {
        if (product) {
            setGroups(prevState => { return { ...prevState, loadingProduct: false } });
        } else {
            setGroups(prevState => { return { ...prevState, loadingProduct: true } });
        }
    }, [product]);

    const openDeleteProductModal = () => {
        setShow2fa(prevState => { return { ...prevState, open: true } });
    }

    const closeDeleteProductModal = () => {
        setShow2fa(prevState => { return { ...prevState, open: false } });
    }

    const verifyOtp = async (OTP, Type) => {
        const res = await onHardDelete({ ActiveCustomerID: activeCustomer, OTP, Type, ProductID: product.ProductID });
        if (res === 200) {
            setShow2fa(prevState => { return { ...prevState, open: false } });
            History.goBack();
        }
    }

    if (redirect) {
        switch (props.type) {
            case 'PCProduct':
                return (<Redirect to="/products/pc-products" />)
            default:
                break;
        }
    }

    if (redirectOptions.redirect) {
        return <Redirect to={redirectOptions.redirectPath} />;
    }

    const showHardDeleteButton = hasPermission(permissions, 'product_hard_delete') && twoFaEnabled && show2fa?.Authentications && Object.keys(show2fa?.Authentications)?.length > 0;

    const hasAccessAllGroupsPermission = hasPermission(permissions, 'access_all_groups');

    const defaultGroupValue = hasAccessAllGroupsPermission ? (product && product.GroupID && groups?.list?.find((g) => g.GroupID === product.GroupID)) || { GroupID: null, Name: translations['none'] || "None" } : (product && product.GroupID && groups?.list?.find((g) => g.GroupID === product.GroupID));

    const loadingScreen = <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={groups.loading} PaperProps={{ classes: { root: classes.loading } }}>
        <AppLogoLoading />
    </Dialog>

    return <>
        {hasPermission(permissions, 'product_delete') ? <ProductDelete translations={translations} activeCustomer={activeCustomer} entityName={props.type} handleDelete={handleDelete} deleteModalState={deleteModalState} deleteProduct={props.onDeleteProduct} bulkDeleteProducts={props.onBulkDeleteProducts} /> : null}
        {hasPermission(permissions, 'product_change_palette') ? <ChangePalette translations={translations} activeCustomer={activeCustomer} editable={editable} moveToAnotherPalette={props.moveToAnotherPalette} product={props.product.loaded} handleChangePalette={handleChangePalette} changePaletteState={changePaletteModalState} /> : null}

        <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={!loading && tabValue < 5 && tabValue !== 2}
            PaperProps={{
                classes: {
                    root: classes.paper
                }
            }}
        >
            <AppLogoLoading />
        </Dialog>
        <div className="tooltip">
            <QRCode
                size={50}
                className={classes.qrCode}
                value={`<Product>${product?.InventoryID}</Product>`}
            />
            <span>
                <QRCode
                    size={200}
                    value={`<Product>${product?.InventoryID}</Product>`}
                />
            </span>
        </div>
        {hasPermission(permissions, 'product_change_palette') ? <Button variant='contained' className={classes.buttonOne} disabled={!editable} onClick={handleChangePalette}>{translations['change_palettes'] || 'Change palettes'}</Button> : null}

        {hasPermission(permissions, 'product_change_group') &&
            <Button variant='contained' className={classes.button} onClick={openChangeGroupModal} disabled={!editable}>{translations["change_group"] || 'Change group'}</Button>}

        {hasPermission(permissions, 'product_get_log_data') ? <Button variant='contained' className={classes.button} onClick={props.getLogData} >{translations['get_log_data'] || 'Get log data'}</Button> : null}
        {hasPermission(permissions, 'product_delete') ? <Button variant='contained' disabled={!editable} onClick={handleDelete} className={classes.button} value={props.productID}>{translations['delete'] || 'Delete'}</Button> : null}
        {showHardDeleteButton &&
            <Button variant='contained' className={classes.deleteButton} onClick={openDeleteProductModal}>{translations["hard_delete"] || 'Hard delete'}</Button>}
        {hasPermission(permissions, 'product_view_history') ? <Button variant='contained' onClick={() => productHistoriesHandler(props.productID)} className={classes.button} value={props.productID}>{translations['product_history_view'] || "View product histories"}</Button> : null}
        {hasPermission(permissions, 'product_print_label') ? <Button variant='contained' onClick={() => handlePrintLabel(props.productID)} className={classes.button} value={props.productID}>{translations['print_label'] || "Print label"}</Button> : null}
        {hasPermission(permissions, 'product_unlock') ? !editable ? <Button variant='contained' className={classes.button} onClick={unlockEdit}>{translations['unlock'] || 'Unlock'}</Button> : null : null}
        {hasPermission(permissions, 'product_send_external_data') ? <Button variant='contained' className={classes.button} onClick={handleSendExternalData}>{translations['send_external_data'] || 'Send External Data'}</Button> : null}
        {hasPermission(permissions, 'product_send_erasure_report') ? <Button variant='contained' className={classes.button} onClick={handleSendErasureReports}>{translations['send_erasure_report'] || 'Send Erasure Report'}</Button> : null}
        {
            props.type === 'PCProduct' && loading && !refresh ?
                hasPermission(permissions, 'product_load') ? <PCProductDetails setExternal={setExternal} external={external} translations={translations} activeCustomer={activeCustomer} columnsState={props.columns} saveColumnsFilter={props.saveColumnsFilter} onUnpairBulkExternalPC={props.onUnpairBulkExternalPC} onFetchProduct={props.onFetchProduct} setLoading={setLoading} onUnpairExternalPC={props.onUnpairExternalPC} activeExternalServiceAvailable={props.activeExternalServiceAvailable} permissions={permissions} editable={editable} product={props.product.loaded} grades={grades} gradingCategories={gradingCategories} typicalProblems={typicalProblems} onEditProduct={props.onEditProduct} onDeleteProduct={props.onDeleteProduct} onBulkDeleteProducts={props.onBulkDeleteProducts} /> : null
                : null
        }
        {hasPermission(permissions, 'product_print_label') ? <PrintLabelForm type={'pcProduct'} translations={translations} isPrinted={isPrinted} activeCustomer={activeCustomer} printLabel={props.onPrintLabel} userSettings={props.userSettings} productID={printLabelState.productID} open={printLabelState.open} printers={printLabelState.printers} handleOpen={handlePrintLabel} /> : null}

        {loadingScreen}
        {!groups.loading && !groups.loadingProduct && <ChangeGroupModal permissions={permissions} defaultValue={defaultGroupValue} modalState={changeGroupModal} handleCloseDanger={handleChangeGroupCloseDanger} handleCloseSafe={handleChangeGroupCloseSafe} translations={translations} groups={groups.list} />}
        <AuthenticatorAppModal translations={translations} modal={show2fa} loginInfo={show2fa} handleClose={closeDeleteProductModal} verifyOtp={verifyOtp} submitButtonText={translations["hard_delete"] || 'Hard delete'} />
    </>
}

const mapStateToProps = state => {
    return {
        twoFaEnabled: state?.core?.login?.user?.AuthenticationEnabled,
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        activeWarehouseID: state.core.login.user.ActiveWarehouseID,
        activeExternalServiceAvailable: state.core.login.activeExternalServiceAvailable,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        columns: state.core.login.userSettings ? state.core.login.userSettings.Columns : null,
        userSettings: state?.core?.login?.userSetting,
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onProductPrinted: pcProduct => dispatch(actions.isPrintedLabel(pcProduct)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        fetchUserSettings: (id) => dispatch(userActions.fetchUserSettings(id)),
        onFetchPrinters: (id) => dispatch(actions.fetchPrinters(id)),
        onPrintLabel: data => dispatch(actions.printLabel(data)),
        onFetchBulkChangeProductsGroup: data => dispatch(fetchBulkChangeProductsGroup(data)),
        onFetchGroups: data => dispatch(fetchGroups(data)),
        onHardDelete: data => dispatch(hardDelete(data)),
        onSendExternalData: params => dispatch(actions.sendExternalData(params)),
        onSendErasureReports: params => dispatch(actions.sendErasureReports(params)),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ProductDetails))